"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const store_1 = require("@ngrx/store");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
require("rxjs/add/operator/debounceTime");
const Observable_1 = require("rxjs/Observable");
const multilingual_type_helper_1 = require("../../shared/multilingual-type-helper");
const path_processing_helper_1 = require("../../shared/path-processing-helper");
const list_export_settings_model_1 = require("../../views/list/list-export-settings.model");
const common_helper_functions_1 = require("../shared/common-helper-functions");
const main_settings_1 = require("../shared/settings/main-settings");
const list_options_model_1 = require("./list-options.model");
const list_report_model_1 = require("./shared/list-report.model");
const list_model_1 = require("./shared/list.model");
/**
 * Component to design and build the structure of a list report. Tightly coupled with numerous services for proper
 * operation. Dynamically reacts on changes to the input properties.
 * @see ListModel
 * @see ListReportModel
 * @see ReportOptions
 * @see FilterTreeDto
 */
let ListBuilderComponent = class ListBuilderComponent extends main_settings_1.MainSettings {
    constructor(pathService, currentLanguageProvider, messageService, languageService, datasetService, store, communicationService) {
        super(communicationService);
        this.pathService = pathService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.messageService = messageService;
        this.languageService = languageService;
        this.datasetService = datasetService;
        this.store = store;
        this.fontNameList = [
            'Arial',
            'Arial Black',
            'Verdana',
            'Times New Roman',
            'Courier',
            'Lucida Console',
            'Roboto',
            'Helvetica',
            'Tahoma',
            'Georgia',
            'Palatino',
            'Monaco'
        ];
        this.headerFontStyleExpanded = false;
        this.footerFontStyleExpanded = false;
        this.subscriptions = [];
        this._headerFontStyle = null;
        this._footerFontStyle = null;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(messageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(datasetService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(store);
        this.dataset = null;
        this.model = null;
        this.options = null;
        this._listModelState = null;
        this.listStateChange = new core_1.EventEmitter();
        this.listModel = null;
        this.datasetDtoComboboxOptions = [];
    }
    get isUnspecifiedExcluded() {
        return this._isUnspecifiedExcluded;
    }
    set isUnspecifiedExcluded(value) {
        this._isUnspecifiedExcluded = value;
        this.emitState();
    }
    get isHeaderIncluded() {
        return this._isHeaderIncluded;
    }
    set isHeaderIncluded(value) {
        this._isHeaderIncluded = value;
        this.emitState();
    }
    get exportHeader() {
        return this._exportHeader;
    }
    set exportHeader(value) {
        if (!this.isHeaderIncluded)
            return;
        this._exportHeader = value;
        this.emitState();
    }
    get isFooterIncluded() {
        return this._isFooterIncluded;
    }
    set isFooterIncluded(value) {
        this._isFooterIncluded = value;
        this.emitState();
    }
    get headerFontStyle() {
        return this._headerFontStyle;
    }
    set headerFontStyle(value) {
        this._headerFontStyle = value;
        this.emitState();
    }
    get footerFontStyle() {
        return this._footerFontStyle;
    }
    set footerFontStyle(value) {
        this._footerFontStyle = value;
        this.emitState();
    }
    get exportFooter() {
        return this._exportFooter;
    }
    set exportFooter(value) {
        if (!this.isFooterIncluded)
            return;
        this._exportFooter = value;
        this.emitState();
    }
    get isPageNumberIncluded() {
        return this._isPageNumberIncluded;
    }
    set isPageNumberIncluded(value) {
        if (!this.isFooterIncluded)
            return;
        this._isPageNumberIncluded = value;
        this.emitState();
    }
    get listState() {
        return this._listState;
    }
    /**
     *  This property stores control state, which will be used in case of dynamic forms.
     */
    set listState(listState) {
        this.initDatasetsComboboxOptions();
        listState && listState["state"] === "" && listState["datasetId"] === "" && (listState = null);
        this._listState = listState;
        listState && (this.dataset = listState["datasetId"] !== "" ? listState["datasetId"] : null);
        listState && (this._listModelState = listState["state"]);
        listState && (this._reportTitle = (!(listState["title"]) ? null : multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(listState["title"])));
    }
    get selectedDatasetId() {
        return this._selectedDatasetId;
    }
    /**
     * Sets the id of selected dataSet and resets state.
     * @param {number} selectedDatasetId
     */
    set selectedDatasetId(selectedDatasetId) {
        if (selectedDatasetId > 0) {
            this._selectedDatasetId = selectedDatasetId;
            this.dataset = selectedDatasetId;
            this.listModel = new list_model_1.ListModel();
            this.createListModelAndOptions();
            this.resetState();
            this.emitState();
        }
    }
    /**
     * @inheritDoc
     */
    ngOnChanges(changes) {
        const listStateChanged = changes["listState"];
        if (listStateChanged && !listStateChanged.isFirstChange() && (this.listStateEmitted === null || this._listState != this.listStateEmitted)) {
            this.createListModelAndOptions(this._listModelState);
            this.resetState();
        }
    }
    /**
     * @inheritDoc
     */
    ngOnDestroy() {
        this.clearState();
        this.clearReportTitleSubscription();
    }
    /**
     * @inheritDoc
     */
    ngOnInit() {
        this.resetState();
        this.connect()
            .then(() => {
            this.resetReportTitleSubscription();
            this.createListModelAndOptions(this._listModelState);
            this.resetState();
        })
            .catch((err) => {
            console.warn("Failed with the following error: %o", err);
        });
    }
    onSelectedCategoriesChange(categories) {
        this.rowCategoriesSelected = categories;
        this.emitState();
    }
    /**
     * Handle editing event on the selected group.
     * @param {Array<MeasureModel>} measures
     */
    onSelectedMeasuresChange(measures) {
        this.columnMeasuresSelected = measures;
        this.emitState();
    }
    changeFilter(isValid) {
        isValid && this.emitState();
    }
    /**
     * @override
     * Create output objects form current state.
     */
    stateToOutputs() {
        // Prepare report's model.
        let model = new list_report_model_1.ListReportModel();
        model.rowCategories = this.rowCategoriesSelected || [];
        model.columnMeasures = this.columnMeasuresSelected || [];
        // Prepare report's options.
        let options = new idm_reporting_service_client_js_1.ReportOptions();
        if (this.options) {
            options = new idm_reporting_service_client_js_1.ReportOptions(this.options.showIndicatorDisaggregations, this.isUnspecifiedExcluded, this.options.fetchNames, this.options.outSidePathHolderIds, this.options.fetchTotalCount, this.options.fetchBranchIndexes, this.options.fetchLevelIndexes, this.options.fetchColumnIndexes);
        }
        let listOptions = new list_options_model_1.ListOptions();
        let isPageNumberIncluded = this.isFooterIncluded ? this.isPageNumberIncluded : false;
        let exportFooter = this.isFooterIncluded && this.exportFooter ? this.exportFooter : multilingual_type_helper_1.MultilingualTypeHelper.createBlankMultilingualString(this.languages);
        let exportHeader = this.isHeaderIncluded && this.exportHeader ? this.exportHeader : multilingual_type_helper_1.MultilingualTypeHelper.createBlankMultilingualString(this.languages);
        let listExportSettings = new list_export_settings_model_1.ListExportSettings();
        listExportSettings.isHeaderIncluded = this.isHeaderIncluded;
        listExportSettings.exportHeader = exportHeader;
        listExportSettings.isFooterIncluded = this.isFooterIncluded;
        listExportSettings.exportFooter = exportFooter;
        listExportSettings.isPageNumberIncluded = isPageNumberIncluded;
        listExportSettings.headerFontStyle = this.headerFontStyle;
        listExportSettings.footerFontStyle = this.footerFontStyle;
        listOptions.listExportSettings = listExportSettings;
        //Update chart state
        this.model = model;
        this.options = options;
        this.listOptions = listOptions;
        // Emit out list state and store it.
        this.listModel.listReportModel = model;
        this.listModel.reportOptions = options;
        this.listModel.listOptions = listOptions;
        let title = (!this.reportTitle ? null : multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.reportTitle));
        this.listStateEmitted = {
            state: this.listModel.toJsonString(),
            datasetId: this.dataset,
            title: title
        };
        this.listStateChange.emit(this.listStateEmitted);
    }
    /**
     * Set all the internal state to its default.
     */
    clearState() {
        this.rowCategoryPaths = new Map();
        this.columnMeasurePaths = new Map();
        this.clearPathsSubscription();
        this.clearSubscriptions();
        this.rowCategories = [];
        this.columnMeasures = [];
        this._isUnspecifiedExcluded = null;
        this.rowCategoriesSelected = null;
        this.columnMeasuresSelected = null;
        this.clickedGroupItem = null;
        this.selectedListItem = null;
        this._exportHeader = null;
        this._exportFooter = null;
        this._isPageNumberIncluded = false;
        this._isFooterIncluded = false;
        this._isHeaderIncluded = false;
        this.languages = [];
        this.currentLanguage = null;
        this.listStateEmitted = null;
        this.datasetDtoName = null;
        this._headerFontStyle = null;
        this._footerFontStyle = null;
    }
    clearSubscriptions() {
        if (this.subscriptions && this.subscriptions.length !== 0) {
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
        }
        this.subscriptions = [];
    }
    /**
     * Re-sets and re-initializes state of the component. Might be called on component initialization or changes to any
     * of the inputs. Initially loads some paths's data from services.
     * @see PathService
     */
    resetState() {
        this.clearState();
        this.subscriptions.push(skynet_store_currencies_api_1.getDefaultCurrency(this.store)
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((currencyModel) => {
            this.defaultCurrencyId = currencyModel.id;
        }));
        // Load all available languages in the system.
        this.subscriptions.push(this.languageService.getAvailableLanguages()
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((languages) => {
            this.languages = languages;
        }));
        // Load the current system language.
        this.subscriptions.push(this.currentLanguageProvider.getCurrentLanguage()
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((language) => {
            this.currentLanguage = language;
        }));
        if (Number.isInteger(this.dataset)) {
            Promise.all([path_processing_helper_1.loadPaths(this.dataset, this.pathService), path_processing_helper_1.loadPathGroups(this.dataset, this.pathService), path_processing_helper_1.loadDatasetById(this.dataset, this.datasetService)])
                .then(([paths, pathGroups, datasetName]) => {
                let availableRowCategoryPaths = new Map();
                let availableColumnMeasurePaths = new Map();
                // Filter paths for rows.
                path_processing_helper_1.extractAvailablePaths(paths.categoryPaths, availableRowCategoryPaths);
                // Filter paths for columns.
                path_processing_helper_1.extractAvailablePaths(paths.measurePaths, availableColumnMeasurePaths, true);
                this.pathGroups = pathGroups;
                this.rowCategoryPaths = availableRowCategoryPaths;
                this.columnMeasurePaths = availableColumnMeasurePaths;
                // Create options from the inputs and subscribe to language chages to recreate appropriately.
                this.resetPathsSubscription(this.rowCategoryPaths, this.columnMeasurePaths, this.pathGroups);
                this.datasetDtoName = datasetName;
            })
                .catch((err) => {
                return common_helper_functions_1.defaultPromiseErrorHandler(err);
            })
                .catch(() => {
                this.clearState();
            });
        }
    }
    /**
     * Un-subscribe and unset the subscription to the changes of the paths.
     */
    clearPathsSubscription() {
        if (this.pathsSubscription) {
            this.pathsSubscription.unsubscribe();
        }
        this.pathsSubscription = null;
    }
    /**
     * Subscribe and set the subscription to the changes of the paths in relation to the current language.
     * @param {PathsMap} rowCategoryPaths - Category paths used in rows.
     * @param {PathsMap} columnMeasurePaths - Measure paths used in columns (if category then default name measure assumed).
     * @param {Array<PathGroupDto>} pathGroups - The grouping metadata for the combo-box options.
     * @see CurrentLanguageProvider
     * @see MessageService
     */
    resetPathsSubscription(rowCategoryPaths, columnMeasurePaths, pathGroups) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(rowCategoryPaths);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(columnMeasurePaths);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathGroups);
        this.clearPathsSubscription();
        this.pathsSubscription = Observable_1.Observable
            .zip(this.currentLanguageProvider.getCurrentLanguage(), this.messageService.getMessage("reporting.controls.list-builder.text.ungrouped"))
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe(([language, message]) => {
            // Translate all available item options.
            this.rowCategories = path_processing_helper_1.initGroupedComboOptions(rowCategoryPaths, pathGroups, language, message);
            this.columnMeasures = path_processing_helper_1.initGroupedComboOptions(columnMeasurePaths, pathGroups, language, message, undefined, this.defaultCurrencyId);
            // Prepare state from input model for the first time only.
            this.stateFromInputs();
        });
    }
    loadDatasets() {
        return this.datasetService.getDatasets();
    }
    /**
     * Creates combo box options for dataSet combo box.
     */
    initDatasetsComboboxOptions() {
        this.loadDatasets()
            .then((datasetDtos) => {
            let options = [];
            datasetDtos.forEach((datasetDto) => {
                options.push(new idm_ng_controls_1.ComboboxOption(datasetDto.id, datasetDto.name));
            });
            this.datasetDtoComboboxOptions = options;
        })
            .catch((err) => {
            return common_helper_functions_1.defaultPromiseErrorHandler(err);
        });
    }
    /**
     * Parse inputs and recover internal view's state.
     */
    stateFromInputs() {
        if (this.rowCategoriesSelected === null) {
            if (this.model && this.model.rowCategories) {
                // Populate initially selected options for row categories.
                this.rowCategoriesSelected = this.model.rowCategories;
            }
            else {
                // Set empty state.
                this.rowCategoriesSelected = [];
            }
        }
        if (this.columnMeasuresSelected === null) {
            if (this.model && this.model.columnMeasures) {
                // Populate initially selected options for column measures.
                this.columnMeasuresSelected = path_processing_helper_1.setCurrenciesOfMeasures(this.columnMeasures, this.model.columnMeasures);
            }
            else {
                // Set empty state.
                this.columnMeasuresSelected = [];
            }
        }
        if (this.isUnspecifiedExcluded === null) {
            if (this.options) {
                // Prepare initial value of the checkbox.
                this._isUnspecifiedExcluded = this.options.hideUnspecifiedRowHierarchy;
            }
            else {
                // Set empty state.
                this._isUnspecifiedExcluded = false;
            }
        }
        if (this.listOptions && this.listOptions.listExportSettings) {
            this._isHeaderIncluded = this.listOptions.listExportSettings.isHeaderIncluded;
            this._isFooterIncluded = this.listOptions.listExportSettings.isFooterIncluded;
            this._isPageNumberIncluded = this.listOptions.listExportSettings.isPageNumberIncluded;
            this._headerFontStyle = this.listOptions.listExportSettings.headerFontStyle;
            this._footerFontStyle = this.listOptions.listExportSettings.footerFontStyle;
            if (this.exportHeader === null) {
                if (this.listOptions && this.listOptions.listExportSettings) {
                    // Prepare initial value of the multilingual text box.
                    this._exportHeader = this.listOptions.listExportSettings.exportHeader;
                }
                else {
                    // Set empty state.
                    this._exportHeader = multilingual_type_helper_1.MultilingualTypeHelper.createBlankMultilingualString(this.languages);
                }
            }
            if (this.exportFooter === null) {
                if (this.listOptions && this.listOptions.listExportSettings) {
                    // Prepare initial value of the multilingual text box.
                    this._exportFooter = this.listOptions.listExportSettings.exportFooter;
                }
                else {
                    // Set empty state.
                    this._exportFooter = multilingual_type_helper_1.MultilingualTypeHelper.createBlankMultilingualString(this.languages);
                }
            }
        }
    }
    /**
     * These method create and initialize list model and properties
     * @param state
     */
    createListModelAndOptions(state) {
        this.listModel = new list_model_1.ListModel();
        state && this.listModel.fromJsonString(state);
        this.model = this.listModel.getListReportModel();
        this.options = this.listModel.getReportOptions();
        this.listOptions = this.listModel.getListOptions();
    }
    emitState() {
        this.stateToOutputs();
        this.sendPreviewMessageToParent();
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ListBuilderComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ListBuilderComponent.prototype, "dataset", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", list_report_model_1.ListReportModel)
], ListBuilderComponent.prototype, "model", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_reporting_service_client_js_1.ReportOptions)
], ListBuilderComponent.prototype, "options", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", list_options_model_1.ListOptions)
], ListBuilderComponent.prototype, "listOptions", void 0);
__decorate([
    core_1.Output("stateChange"),
    __metadata("design:type", core_1.EventEmitter)
], ListBuilderComponent.prototype, "listStateChange", void 0);
__decorate([
    core_1.Input("state"),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ListBuilderComponent.prototype, "listState", null);
ListBuilderComponent = __decorate([
    core_1.Component({
        
        template: require('./list-builder.component.html'),
        selector: "sis-list-builder",
        styles: [require('./list-builder.component.css')]
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: "<sis-list-builder [id]='%{id}' [state]='%{state}' (stateChange)='%{stateChange}'></sis-list-builder>",
    }),
    __param(6, core_1.Optional()),
    __metadata("design:paramtypes", [idm_dataset_service_client_js_1.PathService, idm_session_data_provider_api_js_1.CurrentLanguageProvider, idm_message_language_service_client_js_1.MessageService,
        idm_message_language_service_client_js_1.LanguageService, idm_dataset_service_client_js_1.DatasetService, store_1.Store,
        idm_dynamic_controls_metadata_1.CommunicationService])
], ListBuilderComponent);
exports.ListBuilderComponent = ListBuilderComponent;
//# sourceMappingURL=list-builder.component.js.map